import { TCity, citiesServiceHandlers } from '../../..'
import { useNotification } from '@/core'
import { useMutation } from '@tanstack/vue-query'
import { AxiosError } from 'axios'

export const useCityQuery = () => {
  const { errorHttpNotification } = useNotification()

  const addRecord = useMutation<TCity, AxiosError, TCity>(
    (payload: TCity) => citiesServiceHandlers.addRecord(payload),
    {
      onError: (error) => errorHttpNotification(error),
    },
  )

  return {
    addRecord,
  }
}
